import React, {useEffect, useState} from 'react';
import {MdOutlineArrowCircleRight} from "react-icons/md";
import {FaFlaskVial} from "react-icons/fa6";
import {Link, useOutletContext} from "react-router-dom";
import {getLabCourseExperiments} from "../../services/CourseRepository";
import {useError} from "../../hooks/useError";
import {experiment_palette, getInterpolatedColor} from "../color/Palettes";
import {routes} from "../../utils/Routes";

export function LabCoursePanel() {

    const [experiments, setExperiments] = useState([])
    const {courseId} = useOutletContext()
    const {setErrorMessage} = useError()

    useEffect(() => {
        if(courseId != null) {
            getLabCourseExperiments(courseId+"_LAB", setErrorMessage).then(result => setExperiments(result))
        }
    }, []);

    if(experiments == null || experiments.length === 0) {
        return null;
    }
    return (
        <div className={"row"}>
            <div className={"col"}>
                <div>
                    {
                        experiments.map((experiment, idx) => (
                            <div className={"d-flex mb-2 p-2 border border-2 rounded align-items-center"}>
                                <FaFlaskVial className={" me-2"} style={{color:getInterpolatedColor(experiment_palette,idx, 0, experiments.length)}} size={28} />
                                <h5>{experiment.name}</h5>
                                <Link to={routes.labPage(experiment.name)} className={"text-decoration-none text-dark p-0 m-0"}>
                                    <MdOutlineArrowCircleRight size={24} className={"ms-2"}/>
                                </Link>
                            </div>
                        ))
                    }
                </div>
            </div>
            <div className={"col "}>
                <div className={"d-flex"}>
                    <FaFlaskVial size={32} className={"me-2"}/>
                    <h4>Labhefte</h4>
                </div>

                <p className={"text-justify p-0 m-0 mb-2"}>
                    Usikker på hvordan de ulike forsøkene foregår? Bla deg gjennom vårt labhefte
                    for å se hvordan forsøk utføres i labben, hva du bør
                    tenke på i forhold til utstyr og sikkerhet, samt relevante spørsmål til
                    eksamen.
                </p>

                <Link to={`${experiments[0].name}`}
                   className={"text-decoration-none btn btn-info text-white"}>
                    <label>Åpne labhefte</label>
                    <MdOutlineArrowCircleRight size={32} className={"ms-2"}/>
                </Link>
            </div>
        </div>

    );
}